import Axios from "axios";
import { headerConfig } from "../helpers/services.helper";

export const authService = {
  login,
  logout,
  isAuthenticated
};

function login(VFUID, password) {
  const data = new FormData();
  data.append("VFUID", VFUID);
  data.append("password", password);

  return Axios.post(
    `${process.env.VUE_APP_API_URL}/insurances/${process.env.VUE_APP_SIMULATOR_CODE}/auth/login`,
    data,
    headerConfig
  );
}

function isAuthenticated() {
  return Axios.get(`${process.env.VUE_APP_API_URL}/api/v1/insurances/${process.env.VUE_APP_SIMULATOR_CODE}/user`, headerConfig);
}

function logout() {
  return Axios.get(`${process.env.VUE_APP_API_URL}/insurances/${process.env.VUE_APP_SIMULATOR_CODE}/auth/logout`, headerConfig);
}
